export default __webpack_public_path__ + "static/media/GAVResortsOriginal.da45e919.svg";